import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
    getImplementationDeactivationInfo,
    ImplementationDeactivationBanner,
} from '@Sage/ssm-web5';

import ExcessUsersBanner from 'containers/components/ExcessUsersBanner';

export const TopBanner = memo(
    ({
        canConfigImplementation,
        expectedDeactivationDate,
        freeTrialRemaining,
        subscriptionModeCode,
    }) => {
        const parsedFreeTrialRemaining = parseInt(freeTrialRemaining, 10);
        const isFreeTrialActive =
            subscriptionModeCode === 'free_trial' && !(parsedFreeTrialRemaining <= 0);
        const { shouldShow } = getImplementationDeactivationInfo(expectedDeactivationDate);

        if (isFreeTrialActive) return null;

        if (canConfigImplementation && shouldShow) {
            return (
                <ImplementationDeactivationBanner
                    expectedDeactivationDate={expectedDeactivationDate}
                />
            );
        }

        return <ExcessUsersBanner />;
    },
);

export const selectTopBannerProps = (state) => ({
    canConfigImplementation: state.config?.permission?.canConfigImplementation,
    expectedDeactivationDate: state.config?.userData?.deactivationImplementationDate,
    freeTrialRemaining: state.config?.userData?.trialPeriodDaysRemaining,
    subscriptionModeCode: state.config?.subscriptionModeCode,
});

const ConnectedTopBanner = () => {
    const topBannerProps = useSelector(selectTopBannerProps);

    return <TopBanner {...topBannerProps} />;
};

TopBanner.displayName = 'TopBanner';
ConnectedTopBanner.displayName = 'ConnectedTopBanner';

export default memo(ConnectedTopBanner);
